// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useDevice } from '#imports'
import { defineNuxtPlugin, useHead, useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin((nuxApp) => {
  const { isMobile } = useDevice()
  const environment = useRuntimeConfig()
  const liveChatLicense = environment.public.LIVE_CHAT_LICENSE

  if (!isMobile) {
    window.liveChatEnv = {
      license: liveChatLicense,
    }
    nuxApp.hook('app:mounted', () => {
      useHead({
        script: [
          {
            src: '/assets/lib/live-chat.js',
            defer: true,
          },
        ],
      })
    })
  }
})
